/* ==========================================================================
   SCR redesign — small custom JS (loaded after theme.js).
   ========================================================================== */

/* Move the Shopify Inbox chat activator to the LEFT on mobile.

   The chat renders inside NESTED open shadow DOMs:
     <shopify-chat> #shadow-root
       <shopify-agent-runtime> #shadow-root
         .activator-nudge > button.activator
   Content lives in each element's shadowRoot (not its light DOM), so we must
   descend into shadowRoot explicitly and recurse into nested ones. The widget
   also re-renders on open/close, so we re-run on every mutation of each shadow
   root. .activator-nudge is position:absolute, so inline left/right (!important)
   wins. */
(function () {
  var LEFT = '16px';
  var MOBILE = '(max-width: 767px)';
  var observed = new WeakSet();

  function styleNudge(el) {
    if (window.matchMedia(MOBILE).matches) {
      // guard against loops: only touch it if not already parked left
      if (el.style.getPropertyValue('left') !== LEFT ||
          el.style.getPropertyValue('right') !== 'auto') {
        el.style.setProperty('left', LEFT, 'important');
        el.style.setProperty('right', 'auto', 'important');
      }
    } else if (el.style.getPropertyValue('left') === LEFT) {
      el.style.removeProperty('left');
      el.style.removeProperty('right');
    }
  }

  // Descend into an element's shadow root (if any), style nudges, recurse.
  function scanEl(el) {
    var sr = el.shadowRoot;
    if (!sr) return;
    if (!observed.has(sr)) {
      observed.add(sr);
      new MutationObserver(run).observe(sr, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']
      });
    }
    sr.querySelectorAll('.activator-nudge').forEach(styleNudge);
    sr.querySelectorAll('*').forEach(scanEl);
  }

  function run() {
    var chat = document.querySelector('shopify-chat');
    if (chat) scanEl(chat);
  }

  run();
  // the chat is injected (and can be re-injected) by the app after load
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', run);
})();
